export const PRODUCTS = "products";
export const PRODUCTS_All = "Products_All";
export const PPRODUCT_SELECT_CHANGEVALUE = "ProductSelecteChangeValue";
export const BASEUNIT_SELECT_CHANGEVALUE = "BascUnitSelecteChangeValue";
export const PRODUCT_CHANGEVALUE = "ProductChangeValue";
export const PRODUCT_UNITS_VALUE = "Product_Units_Value";
export const PRODUCT_VENDORS_VALUE = "Product_vendors_value";
export const PRODUCT_IMAGE = "Product_Image";
export const PRODUCT_GROUP_VALUE = "Product_group_value";
export const GET_PRODUCT_ROW_DATA = "get_Product_Row_Data";
export const PRODUCT_ADD = "ProductAdd";
export const PRODUCT_ADD_SUCCESSFUL = "product_add_successfull";
export const PRODUCT_ROW_SUCCESSFUL = "product_row_successfull";
export const GROUP_CHANGEVALUE = "GroupChangeValue";
export const PRODUCT_GROUPS = "Product_product_groups";
export const PRODUCTGROUP_LIST_SUCCESSFUL = "productgroup_list_successfull";
export const PRODUCT_DELETE = "product_deleted";
export const MODEL_OPEN = "Group_model_open";
export const MODEL_CLOSE = "Group_model_close";
export const PRODUCT_LIST_SUCCESSFUL = "product_list_successfull";
export const SET_PARAMS = "product_set_params";
export const API_ERROR = "api_failed";

export const UNITS_MODEL_OPEN = "Add_Product_units_model_open";
export const UNITS_MODEL_CLOSE = "Add_Product_units_model_close";
export const UNITS_CHANGEVALUE = "Add_product_units_change_values";
export const DELETE_UNITS_ROW = "Add_product_delete_unit_row";

export const MR_CUSTOM_PRODUCT = "Add_product_MR_Custom_Product";
